import React from 'react'
import {isArrayAndNotEmpty} from '../observations/Utils'
import {contentMenuTactList} from './TacConstants'

const TermsDoc = () => {
    return (
        <React.Fragment>
            {' '}
            <Section title="ABOUT THESE TERMS AND CONDITIONS:">
                <Paragraph>
                    THESE TERMS AND CONDITIONS (HEREINAFTER REFERRED TO AS THE{' '}
                    <Strong>"AGREEMENT"</Strong> ) SETS FORTH THE LEGALLY
                    BINDING TERMS AND CONDITIONS FOR USER’S USE OF I AM OK
                    AND/OR TAVIE SOFTWARE APPLICATION (HEREINAFTER COLLECTIVELY
                    REFERRED TO AS THE
                    <Strong>“APPLICATION”</Strong> ) AND ALL SERVICES/PRODUCTS
                    WHICH ARE AVAILABLE TO THE USER ON THE APPLICATION
                    (COLLECTIVELY, THE <Strong> “SERVICES”</Strong>).
                </Paragraph>
                <Paragraph>
                    BY ACCESSING AND USING THE APPLICATION AND/OR THE SERVICES
                    IN ANY MANNER, THE USER ACKNOWLEDGE THAT HAS READ,
                    UNDERSTOOD, AND AGREE TO BE BOUND BY THIS AGREEMENT AND THE
                    PRIVACY POLICY:
                    <a
                        className="text-darkcyan font-semibold"
                        href="https://thinkshield.com/#policy">
                        {' '}
                        https://thinkshield.com/#policy
                    </a>{' '}
                    (HEREINAFTER REFERRED TO AS THE{' '}
                    <Strong>“PRIVACY POLICY”</Strong> ), WHICH IS INCORPORATED
                    INTO THIS AGREEMENT BY THIS REFERENCE.
                </Paragraph>
                <Paragraph>
                    <Strong>
                        {' '}
                        PLEASE READ THIS AGREEMENT AND THE PRIVACY POLICY
                        CAREFULLY BEFORE USING THE APPLICATION AND THE SERVICES.
                        AN ABSOLUTE CONDITION FOR THE USER TO ACCESS THE
                        APPLICATION, AS WELL AS TO USE THE SERVICES, IT IS TO
                        ACCEPT THIS AGREEMENT AND THE PRIVACY POLICY. IF THE
                        USER DOES NOT ACCEPT THIS AGREEMENT AND THE PRIVACY
                        POLICY, THE USER IS NOT AUTHORIZED TO ACCESS AND USE THE
                        APPLICATION AND THE SERVICES AND SHALL IMMEDIATELY CEASE
                        USING THEM.
                    </Strong>
                </Paragraph>
            </Section>
            <Section title="​​Contents">
                <Paragraph>
                    <ul
                        className="roman-list"
                        style={{listStyleType: 'upper-roman'}}>
                        {contentMenuTactList.map((item, idx) => (
                            <li key={idx}>
                                <h4 className="mb-2 font-semibold">
                                    {item.label}
                                </h4>
                                <ul className="list-none">
                                    {isArrayAndNotEmpty(item.items) &&
                                        item.items.map((childItem, cIdx) => (
                                            <li key={cIdx}>
                                                <h5 className="mb-1 font-semibold">
                                                    {childItem.label}
                                                </h5>

                                                <ul className="list-none">
                                                    {isArrayAndNotEmpty(
                                                        childItem.childItems,
                                                    ) &&
                                                        childItem.childItems.map(
                                                            (x, xcdx) => (
                                                                <li key={xcdx}>
                                                                    {x}
                                                                </li>
                                                            ),
                                                        )}
                                                </ul>
                                            </li>
                                        ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </Paragraph>
            </Section>
            <Section title="I. Definitions">
                <Paragraph>
                    <Strong>Terms and Conditions:</Strong> these Terms and
                    Conditions for the use of I am OK Application and/or TaVIE
                    Application, and all appendices to them (hereinafter
                    together referred to as the "Agreement").
                </Paragraph>
                <Paragraph>
                    <Strong>Privacy Policy:</Strong> refers to the Company's
                    Data Policy governing the collection, use, and sharing of
                    User data, incorporated in this Agreement and available for
                    the User to the following link address:
                    <a
                        href="https://thinkshield.com/#policy"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://thinkshield.com/#policy
                    </a>
                    .
                </Paragraph>
                <Paragraph>
                    <Strong>Application:</Strong> I am OK software or/and TaVie
                    software cloud application (individually and/or collectively
                    referred to as the “Application”), including all its/their
                    features, functionalities, and content.
                </Paragraph>
                <Paragraph>
                    <Strong>Provider:</Strong> refer to the company -
                    <Strong>4:30 РМ OOD</Strong> as the owner of I am OK
                    Application, or/and to the company-{' '}
                    <Strong>ThinkShield Ltd.</Strong>- as the owner of TaVie
                    Application.
                </Paragraph>
                <Paragraph>
                    <Strong>4:30 РМ OOD:</Strong> a private limited liability
                    company incorporated in Bulgaria with Company Registration
                    Number: 201613143, and having its registered office at: 13
                    Tsvetarska Str., Dragalevtsi district, Vitosha region, Sofia
                    1415, Bulgaria.
                </Paragraph>
                <Paragraph>
                    <Strong>ThinkShield Ltd.:</Strong> a private limited company
                    incorporated in England with the Company Registration
                    Number: 5961513, and having its registered office address
                    at: 4 Furmston Court, Icknield Way, Letchworth Garden City,
                    Hertfordshire, SG6 1UJ, United Kingdom.
                </Paragraph>

                <Paragraph>
                    <Strong>Services:</Strong> include I am OK Application
                    and/or TaVIE Application, and all its/their related features
                    and products.
                </Paragraph>

                <Paragraph>
                    <Strong>User/s:</Strong> refers to any individual accessing
                    and/or using the Application, who is participant in the
                    Wellness Program, as governed by the Organizer of the
                    Wellness Program their Wellness Program is assigned to.
                </Paragraph>

                <Paragraph>
                    <Strong>Smart wearable/s:</Strong> refers to smart watch,
                    bracelet, mobile phone, IoT device and/or any other device
                    that enables WiFi/Bluetooth connectivity allowing the
                    transfer of User’s Data to the cloud-based user Interface
                    and the Application.
                </Paragraph>

                <Paragraph>
                    <Strong>User’s Account:</Strong> unique profile of the User
                    through which the latter can access the Application by
                    unique login feature, that includes designated username and
                    password.
                </Paragraph>

                <Paragraph>
                    <Strong>User’s Data:</Strong> encompasses any information
                    related to the User provided and/or uploaded by: the User,
                    the Organizer of the Wellness program, the Authorized
                    personnel, and/or automatically transmitted by the Smart
                    wearable to the Application.
                </Paragraph>

                <Paragraph>
                    <Strong>User’s Wellness Data:</Strong> encompasses any
                    information related to the User's wellness indicators, that
                    is transmitted by the Smart wearable, including but not
                    limited to: location, steps, sleep, calories, Blood oxygen
                    level (Sp.O2), Heart Rate, Skin Temperature, Seizure Events,
                    and all other visible on the Application information
                    pertaining to the User wellness condition.
                </Paragraph>

                <Paragraph>
                    <Strong>Wellness Program:</Strong> specific program in which
                    the User participates based on an agreement with the
                    Organizer of the Wellness Program.
                </Paragraph>

                <Paragraph>
                    <Strong>Organizer of the Wellness Program:</Strong> Hospital
                    and/or another medical and/or wellness facility to which the
                    User is a patient/client and with which the User has a
                    legally binding agreement for participation in the Wellness
                    Program, and to which the User agreed to grant the right to
                    access User Data transmitted to the Application, as well as
                    to access, upload, record, amend and analyze such data to
                    the Application for the purposes of the Wellness program.
                </Paragraph>

                <Paragraph>
                    <Strong>Authorized personnel:</Strong> medical
                    professionals, designated by the respective Organizer of the
                    Wellness Program to which the User is a patient/client,
                    and/or other medical professionals designated by the User,
                    which have access to User’s Wellness Data transmitted to the
                    Application, and to which the User agreed to grant the right
                    to access, monitor, upload, record, amend and analyze such
                    data for the purposes of the Wellness Program.
                </Paragraph>

                <Paragraph>
                    <Strong>Authorized Individuals:</Strong> refers to
                    individual which the User authorized to access User’s
                    Account and/or Wellness Data on User’s behalf.
                </Paragraph>

                <Paragraph>
                    <Strong>
                        Royal College of Physicians NEWS2 standard guidelines:
                    </Strong>{' '}
                    refers to the following guidelines used as base for the
                    automatically generated notifications to the Users of the
                    Application:{' '}
                    <a
                        href="https://www.rcp.ac.uk/improving-care/resources/national-early-warning-score-news-2/"
                        target="_blank"
                        rel="noreferrer">
                        https://www.rcp.ac.uk/improving-care/resources/national-early-warning-score-news-2/
                    </a>
                    .
                </Paragraph>

                <Paragraph>
                    <Strong>Intellectual Property:</Strong> includes all
                    copyrights, trademarks, patents, trade secrets, and other
                    proprietary rights associated with the Application and its
                    content.
                </Paragraph>
            </Section>
            <Section title="II. General Provisions">
                <Paragraph>
                    By accessing and using the Application the User accept and
                    agree to the terms of this Agreement, and thus, a valid
                    contract is concluded between the User and the Provider, for
                    the use of the Application. The Provider may modify this
                    Agreement, the Privacy Policy, and/or the Services at any
                    time and such modification will be effective upon posting
                    such modifications to the Application website. User’s
                    continued use of the Application and Services offered after
                    the date the amended Agreement, Privacy Policy, and/or
                    Service is posted, shall constitute User’s acceptance of
                    such amendments.
                </Paragraph>
                <Paragraph>
                    In case of material changes to this Agreement, the Privacy
                    Policy, and/or the Services, Users shall have the right to
                    terminate this Agreement within ten (10) days of the
                    modification coming into effect, by notifying the Organizer
                    of the Wellness Program, in accordance with Section XV
                    below. Material changes shall be deemed to include, but are
                    not limited to, substantial changes affecting the scope of
                    Services, data usage policies, privacy protections, or User
                    rights and obligations. Users will be provided with notice
                    of such changes and they will have the right to terminate
                    this Agreement within the 10 days’ period after receiving
                    the notice. Users continued use of the Application and
                    Services, after the expiration of the period in the previous
                    sentence, shall constitute Users acceptance of such material
                    amendments.
                </Paragraph>
                <Paragraph>
                    Notwithstanding the foregoing, the resolution of any dispute
                    arising between the Users and the Provider in connection
                    with the use of the Application and the Services shall be
                    settled in accordance with the Agreement which was current
                    at the time the dispute arose. In the event that the Users
                    do not agree with the provisions of this Agreement, it shall
                    be considered that the User does not have the right to
                    access and use the Application and the same would
                    accordingly be considered unregulated. This Agreement apply
                    to all Users using the Application, regardless of the
                    purposes and manner of using the Application.
                </Paragraph>
                <Paragraph>
                    In the event that the Application cannot be accessed at a
                    certain time (due to the fault of the Provider), the
                    Provider shall conduct activities to eliminate the problem
                    and shall make reasonable efforts to restore the access to
                    the Application and the Services. Regardless of the above,
                    the Users acknowledge and agree that the Provider does not
                    guarantee that the Application will be accessible and
                    available for Users, nor bears any responsibility whatsoever
                    for material and/or non-material damages arising as a result
                    of terminated, interrupted, and/or lack of access to the
                    Application and/or the Services.
                </Paragraph>
                <Paragraph>
                    Users acknowledge and agree that, to receive access to the
                    Application, the Services and the Smart wearables, Users
                    need to be part of а Wellness Program, аs described in
                    Section V below, and shall have an agreement with the
                    respective Organizer of the Wellness Program that allows
                    them to participate in the Wellness Program.
                </Paragraph>
                <Paragraph>
                    <Strong>
                        USERS ACKNOWLEDGE AND AGREE THAT THE APPLICATION DOES
                        NOT PROVIDE MEDICAL AND/OR WELLNESS SERVICES, OR PERFORM
                        MEDICAL AND/OR WELLNESS ACTIVITIES. USERS ACKNOWLEDGE
                        AND AGREE THAT THE PROVIDER AND THE APPLICATION IS NOT A
                        MEDICAL AND/OR WELLNESS FACILITY, THAT THE APPLICATION
                        AND THE SERVICES DO NOT CONSTITUTE A MEDICAL DEVICE
                        AND/OR MEDICAL AND/OR WELLNESS SERVICES, AND THAT SUCH
                        ARE NOT PROVIDED BY THE PROVIDER OR THE APPLICATION.
                        USERS ACKNOWLEDGE AND AGREE THAT ANY INFORMATION
                        CONTAINED IN AND/OR TRANSFERRED THROUGH THE APPLICATION
                        AND/OR USED FOR MEDICAL OR OTHER PURPOSES BY THE USER
                        AND/OR THE ORGANIZER OF THE WELLNESS PROGRAM/AUTHORIZED
                        PERSONNEL, SUCH AS DIAGNOSIS, PREVENTION, TREATMENT,
                        ETC., SHALL BE PROFESSIONALLY VERIFIED AND APPROVED BY
                        THE RELEVANT INDEPENDENT ORGANIZER OF THE WELLNESS
                        PROGRAM/ AUTHORIZED PERSONNEL, AND ANY SERVICE (WHETHER
                        NON-MEDICAL OR MEDICAL SERVICE) PROVIDED BASED ON THIS
                        INFORMATION, IS AND SHALL BE PROVIDED ONLY AND
                        EXCLUSIVELY BY THE RELEVANT ORGANIZER OF THE WELLNESS
                        PROGRAM AND/OR AUTHORIZED PERSONNEL. USERS ACKNOWLEDGE
                        AND AGREE THAT ANY INFORMATION, INPUT OR ADVICE THEY
                        RECEIVE FROM THE AUTHORIZED PERSONNEL COMES FROM THE
                        RESPECTIVE PERSONNEL OF THE ORGANIZER OF THE WELLNESS
                        PROGRAM AND NOT FROM THE PROVIDER OR FROM THE
                        APPLICATION. USERS ACKNOWLEDGE AND AGREE THAT THEIR
                        INTERACTIONS WITH THE ORGANIZER OF THE WELLNESS
                        PROGRAM/AUTHORIZED PERSONNEL, VIA THE APPLICATION AND
                        THE SERVICES, ARE NOT INTENDED TO TAKE THE PLACE OF
                        USERS RELATIONSHIP(S) WITH USERS REGULAR/OTHER
                        HEALTHCARE PRACTITIONER(S). USERS ACKNOWLEDGE AND AGREE
                        THAT THE PROVIDER OF THE APPLICATION IS NOT RESPONSIBLE
                        FOR ANY SERVICE (WHETHER NON-MEDICAL OR MEDICAL SERVICE)
                        PROVIDED BASED ON THE INFORMATION CONTAINED IN OR
                        TRANSMITTED THROUGH THE APPLICATION, OR ANY SERVICES
                        PROVIDED THROUGH THE APPLICATION. USERS ACKNOWLEDGE THAT
                        THE APPLICATION IS AN INFORMATIONAL TOOL USED BY MEDICAL
                        PROFESSIONALS AND/OR OTHER HEALTHCARE PROFESSIONALS FOR
                        DISTANCE MONITORING OF USER’S WELLNESS INDICATORS, AND
                        THAT THE APPLICATION MAY FACILITATE THE COMMUNICATION
                        BETWEEN USERS AND SUCH PROFESSIONALS, BUT IT DOES NOT,
                        IN ANY WAY, REPLACE TRADITIONAL IN-PERSON MEDICAL CHECK
                        AND/OR CONSULTATIONS, OR EMERGENCY SERVICES. USERS
                        ACKNOWLEDGE THAT THEY SHALL DETERMINE AT THEIR OWN RISK
                        WHETHER TO USE THE APPLICATION AND THE SERVICES, AND
                        WHETHER SUCH USE IS APPROPRIATE FOR THEM.{' '}
                    </Strong>
                </Paragraph>
                <Paragraph>
                    <Strong>
                        ALL SERVICES PROVIDED TO USERS AS PARTICIPANTS IN A
                        WELLNESS PROGRAM (INCLUDING MEDICAL AND/OR WELLNESS
                        SERVICES, AND/OR MONITORING SERVICES) ARE DELIVERED
                        SOLELY AND EXCLUSIVELY BY THE ORGANIZER OF WELLNESS
                        PROGRAM AND/OR THE AUTHORIZED PERSONNEL, AT THEIR
                        DISCRETION AND UNDER THEIR RESPONSIBILITY. THE
                        APPLICATION PROVIDER DOES NOT ORGANIZE, PROVIDE, OR
                        PARTICIPATE IN ANY WAY IN THE DELIVERY OF THESE
                        SERVICES.{' '}
                    </Strong>
                </Paragraph>
                <Paragraph>
                    <Strong>
                        USERS ACKNOWLEDGE AND AGREE THAT THE ROLE OF THE
                        PROVIDER UNDER THIS AGREEMENT IS LIMITED TO LICENSOR,
                        GRANTING APPLICATION USAGE RIGHTS TO THE ORGANIZER OF
                        WELLNESS PROGRAM. THE ORGANIZER OF WELLNESS PROGRAM
                        INDEPENDENTLY DECIDES WHICH USERS ARE ELIGIBLE TO
                        PARTICIPATE IN THE WELLNESS PROGRAM AND THEREBY GAIN
                        ACCESS TO THE APPLICATION AND THE SERVICES. THE PROVIDER
                        IS NOT INVOLVED IN ANY DECISIONS REGARDING USER
                        ELIGIBILITY IN PARTICIPATING IN THE WELLNESS PROGRAM OR
                        THE USE OF THE APPLICATION AND THE SERVICES IN THIS
                        CONTEXT.{' '}
                    </Strong>
                </Paragraph>
                <Paragraph>
                    <Strong>
                        USERS ACKNOWLEDGE AND AGREE THAT THE ORGANIZER OF THE
                        WELLNESSS PROGRAM, AS THE USER’S DATA CONTROLLER, IS
                        RESPONSIBLE FOR ALL MATTERS RELATED TO THE UPLOADED,
                        TRANSMITTED, AND/OR AVAILABLE TO THE APPLICATION USER
                        DATA, AS WELL AS FOR ALL DATA AND INFORMATION TO WHICH
                        THE USER HAVE ACCESS THROUGH THE APPLICATION AND THE
                        SERVICES. THE APPLICATION AND THE PROVIDER DO NOT STORE
                        ОR HOST USER DATA. ALL STORAGE AND HOSTING SERVICES
                        RELATED TO USER DATA AND CONTENT ON THE APPLICATOIN IS
                        PROVIDED BY THE RESPECTIVE ORGANIZER OF THE WELLENSS
                        PROGRAM AND/OR BY THIRD PARTIES. THE PROVIDER DO NOT
                        HAVE ACCESS TO USERS’ WELLNESS DATA AND TO THE GENERATED
                        BY THE USERS WHILE USING THE APPLICATION CONTENT.
                    </Strong>
                </Paragraph>
            </Section>
            <Section title="III. Application and Services">
                <ul className="list-none pl-4">
                    <li>
                        <Strong>1. Application </Strong>
                        <Paragraph>
                            The Application is Virtual Inpatient Essentials
                            software application that links wearers of smart
                            watches and other smart technology (i.e. Smart
                            wearables) with a Cloud-based User Interface
                            designed to keep track of the User’s Wellness
                            activity (such as steps, sleep, calories, SPO2,
                            Heart Rate, Skin Temperature, Falls Events, etc.).
                            The Application has been designed to help medical
                            professionals to monitor and observe their patient’s
                            Wellness indicators and activities. Different from
                            other applications used for wellness purposes, this
                            Application is not an AI monitored service, rather
                            it is a human monitored service that ensures trained
                            physicians and medical professionals monitoring
                            their patients, so they can better understand
                            patients’ personal wellness needs.
                        </Paragraph>
                        <Paragraph>
                            The Application is a cloud application that provides
                            connectivity with Smart wearable technology. The
                            Application and the Services allow Users to track
                            and share with the Authorized personnel
                            wellness-related information collected by the Smart
                            wearable. The Аpplication is the interface between
                            the Smart wearable (watch, ECG monitor, insoles
                            tracker, blood glucose monitor or any IoT device
                            that enables WiFi/Bluetooth connectivity) and an
                            observations platform that provides a comprehensive
                            overview of the User’s daily wellness indicators.
                        </Paragraph>
                        <Paragraph>
                            The Application aims to support Users and their
                            dedicated healthcare professionals during their
                            participation in a Wellness Program. The software
                            Application provides a cloud-based monitoring tool
                            for Users and for their dedicated healthcare
                            professionals. When connected, the Smart wearables
                            worn by Users transmit wellness and activity data to
                            the Application for analysis and monitoring by the
                            Authorized personnel.
                        </Paragraph>
                    </li>
                    <li>
                        <Strong>2. Application Services </Strong>
                        <ul className="list-none pl-3">
                            <li>
                                <h5 className="pt-3 font-bold">
                                    {`a) User’s Account and Portal`}
                                </h5>
                                <Paragraph>
                                    The Application provides for the creation of
                                    a personalized wellness profile of the User
                                    (“Users Account”) on the Application, that
                                    contains Users Wellness Data transmitted
                                    from the Smart wearables provided to the
                                    User, and/or used by the User.{' '}
                                </Paragraph>
                                <Paragraph>
                                    The Users have access to their own portal
                                    page by way of a unique login feature that
                                    includes username and password. The User’
                                    Portal also supports a chat feature that
                                    enables User to communicate directly with
                                    the Authorized Personnel.{' '}
                                </Paragraph>
                                <Paragraph>
                                    The User Account is unique and personal, and
                                    every action and declaration of intent made
                                    through it is considered to have been made
                                    by the person named as the owner of the
                                    profile and the latter is considered its
                                    author and owner.{' '}
                                </Paragraph>
                                <Paragraph>
                                    Users should immediately, after being
                                    provided with credentials to enter their
                                    Account on the Application, change their
                                    access password with a unique personal
                                    password that they should not provide or
                                    share with anyone.{' '}
                                </Paragraph>
                                <Paragraph>
                                    In the event of unauthorized access due to a
                                    violation of the Users obligations described
                                    in this Agreement, the latter is responsible
                                    for all actions performed through their
                                    Account, and will indemnify the Provider,
                                    other Users and/or any third parties for all
                                    damages related to the unauthorized access.{' '}
                                </Paragraph>
                                <Paragraph>
                                    Users of the Application assume full
                                    responsibility for maintaining the
                                    confidentiality of access to their Account,
                                    and accept that in case of suspicion of
                                    suspicious activity through their Account or
                                    unauthorized access to the latter, they
                                    should immediately notify the Organizer of
                                    the Wellness program.{' '}
                                </Paragraph>
                                <Paragraph>
                                    Users acknowledge and accept that the
                                    Provider, other Users of the Application and
                                    third parties have the right to engage
                                    User’s responsibility for damages caused to
                                    them, as a result of unauthorized access to
                                    and/or through a specific User Account by
                                    third parties.{' '}
                                </Paragraph>
                                <Paragraph>
                                    The Application may enable Users to give
                                    permission to members of their family or
                                    other individuals to have access to their
                                    Account (“Authorized Individual/s”). In
                                    addition, the Application may enable Users
                                    to give access to their Account to the
                                    Organizer of the Wellness program. When
                                    Users give access to the Organizer of the
                                    Wellness program/Authorized Individual,
                                    Users grant permission to the Organizer of
                                    the Wellness program/Authorized Individuals
                                    to access the information contained within,
                                    and/or perform certain activities through
                                    their Account. Users also may permit their
                                    authorized health care providers to
                                    communicate with such Authorized Individuals
                                    about their wellness and/or health status.{' '}
                                </Paragraph>
                            </li>
                            <li>
                                <h5 className="pt-3 font-bold">
                                    {`b) Track Wellness Data  `}
                                </h5>
                                <Paragraph>
                                    The data transmitted by the Smart wearables
                                    is uploaded automatically to the
                                    Application, when the Smart wearables are
                                    activated and connected to the Application.
                                </Paragraph>
                                <Paragraph>
                                    The Application allows the Users to track
                                    their Wellness indicators and activity.
                                    Depending on the type of the Smart wearables
                                    provided to the User, and/or used by the
                                    User, the following User’s data could be
                                    captured and visualized on the Application:
                                    steps, sleep, calories, SPO2, heart rate,
                                    skin temperature, seizure events, etc.
                                    Depending on the type of the Smart wearables
                                    provided to the User/ used by the User, all
                                    such data is captured and transmitted
                                    regularly from the Smart wearables to the
                                    Application.
                                </Paragraph>
                                <Paragraph>
                                    However, depending on the type of the Smart
                                    wearable provided to the User/used by the
                                    User, the User may need to perform
                                    additional activities in order to allow the
                                    transfer of specific data from the Smart
                                    wearable to the Application.
                                </Paragraph>
                                <Paragraph>
                                    Users are solely responsible for the proper
                                    technical adjustment and calibration of the
                                    Smart wearables provided to them, and/or
                                    used by them. Users are required to follow
                                    the manufacturer’s instructions to ensure
                                    proper calibration and functionality, in
                                    order for the Smart wearables to transmit
                                    data to the Application. The Provider is not
                                    responsible for performing, assisting with,
                                    or ensuring the calibration or adjustment of
                                    the Smart wearables.
                                </Paragraph>
                            </li>
                            <li>
                                <h5 className="pt-3 font-bold">
                                    {`c) Location feature  `}
                                </h5>
                                <Paragraph>
                                    The Location tracking feature is designed to
                                    enhance User wellness journey by providing
                                    information based on User real-time location
                                    data. By analyzing User’s location data over
                                    time, the Organizer of the Wellness Program
                                    and/or the Authorized personnel may provide
                                    valuable insights into Users movement
                                    patterns, habits, and progress towards their
                                    wellness goals.
                                </Paragraph>
                                <Paragraph>
                                    The Location Activity tracking feature
                                    follows strict privacy controls. The User
                                    may customize location sharing preferences,
                                    set boundaries, and control who has access
                                    to the location information. To use the
                                    location feature, the User must enable it
                                    during the initial installation of the
                                    Application. In some case, the Location
                                    feature may be automatically switched on,
                                    and in case the User does not want this
                                    feature, the User should explicitly notify
                                    the Organizer of the Wellness program and
                                    declare its exclusion. Users acknowledge
                                    that if they choose to disable or turn off
                                    their location activity, the Organizer of
                                    the Wellness Program/the Authorized
                                    Personnel will be unable to determine their
                                    exact location, and this may prevent them
                                    from delivering the necessary help or
                                    support. Users acknowledge and agree that
                                    they assume full responsibility for any
                                    consequences that may arise as a result of
                                    the disabled location feature.
                                </Paragraph>
                                <Paragraph>
                                    The Location tracking service maintains
                                    User’s location, providing that the Smart
                                    wearable supports this feature. For
                                    continuous location support the Smart
                                    wearable must be connected to the Internet
                                    either via Wi-Fi or an eSim card.
                                </Paragraph>
                                <Paragraph>
                                    However, if it is not activated then the
                                    Smart wearable must rely on an internet
                                    network for this feature to work or be
                                    linked to a mobile phone which needs to be
                                    carried whenever the User is outside the
                                    home internet.
                                </Paragraph>
                                <Paragraph>
                                    If the User wants to make use of this
                                    location feature continuously the User is
                                    advised to activate an eSIM data plan.{' '}
                                </Paragraph>
                            </li>
                            <li>
                                <h5 className="pt-3 font-bold">
                                    {`d) Notification feature`}
                                </h5>
                                <Paragraph>
                                    The Application provides the User with
                                    notification feature. The Notification
                                    feature aim to keep the User connected and
                                    informed throughout the Wellness program.
                                </Paragraph>
                                <Paragraph>
                                    The notifications are received directly by
                                    the Users, and the Authorized personnel -
                                    who also receive notifications that alert
                                    them to a change in the User wellness state.
                                    In cases where the User has allowed
                                    Authorized individuals to access User’s
                                    Account and/or Wellness Data on User’
                                    behalf, such individuals may also receive
                                    notifications for changes in Users wellness
                                    state.
                                </Paragraph>
                                <Paragraph>
                                    Notifications could be sent to the User via
                                    the Application in cases of:
                                </Paragraph>
                                <Paragraph>
                                    <List
                                        items={[
                                            'a. vitals parameter anomalies; ',
                                            'b. push notifications sent by the Organizer of the Wellness program or the Authorized personnel as appointment reminders; reminders for medication intake and/or reminders to submit data or symptoms; ',
                                            'c. irregularities with the Smart wearables – low battery, dysconnectivity, errors, etc.  ',
                                        ]}
                                    />
                                </Paragraph>
                                <Paragraph>
                                    In cases of notifications for vital
                                    parameter anomalies, such notifications are
                                    based on established parameters that have
                                    been taken from the Royal College of
                                    Physicians NEWS2 standard guidelines
                                    (available on the following web page:
                                    <a href="//www.rcp.ac.uk/improving-care/resources/national-early-warning-score-news-2/">
                                        www.rcp.ac.uk/improving-care/resources/national-early-warning-score-news-2/
                                    </a>
                                    ). When the established parameters exceed
                                    either above or below, the Application will
                                    automatically generate a notification to the
                                    User and to the Authorized personnel.
                                </Paragraph>
                                <Paragraph>
                                    When the Organizer of the Wellness program
                                    /the Authorized personnel have conducted a
                                    health check of the User, prior to the
                                    implementation of the Wellness program, the
                                    parameters can be adjusted according to the
                                    User’s established norm, in order to prevent
                                    unnecessary or erroneous notifications.
                                    Establishing specific parameters for the
                                    User would enable the Organizer of the
                                    Wellness program /the Authorized personnel
                                    to monitor User more safely and potentially
                                    may help the Authorized personnel to predict
                                    some negative outcome for the User before it
                                    happens.{' '}
                                </Paragraph>
                                <Paragraph>
                                    Users acknowledge and agree that the
                                    Provider does not send and does not have
                                    control over any notifications received by
                                    Users through the Application. In addition,
                                    Users acknowledge and agree that such
                                    notification depend on factors beyond
                                    Provider and Application’s control,
                                    including but not limited to: Authorized
                                    personnel availability, Smart wearables
                                    settings, network connectivity, AI
                                    Technology, and other technical limitations,
                                    and Users acknowledge that the receipt and
                                    timing of notifications is also depending of
                                    such factors. The Provider of the
                                    Application disclaims any warranties or
                                    representations regarding the delivery,
                                    accuracy, or reliability of any
                                    notifications. Users are solely responsible
                                    for managing their notification settings and
                                    ensuring that they receive important updates
                                    in a timely manner. The Application and the
                                    Provider shall not be liable for any
                                    damages, losses, or liabilities arising from
                                    the use, interpretation or non-receipt of
                                    notifications.{' '}
                                </Paragraph>
                            </li>
                            <li>
                                <h5 className="pt-3 font-bold">
                                    {`e) Chat feature`}
                                </h5>
                                <Paragraph>
                                    The Chat Feature of the Application enable
                                    the User to communicate directly with the
                                    Organizer of the Wellness program and/or
                                    with the Authorized personnel through the
                                    online portal of the Application. With this
                                    feature, User can ask questions, seek
                                    advice, and receives personalized guidance
                                    from the Organizer of the Wellness
                                    program/the Authorized personnel. The Chat
                                    feature is available on User’s Portal
                                    Account under the heading{' '}
                                    <Strong>“Conversation”</Strong>.
                                </Paragraph>
                                <Paragraph>
                                    The Chat feature facilitates communication
                                    between Users and the Organizer of the
                                    Wellness program/Authorized personnel for
                                    informational purposes only. Users
                                    acknowledge that the chat feature is
                                    available only when the Smart Wearable and
                                    the Application are connected through
                                    Internet network, which is a technical
                                    obstacle beyond Provider’s control. In
                                    addition, Users acknowledge that while the
                                    Organizer of the Wellness program/the
                                    Authorized personnel may be available to
                                    respond to inquiries and engage in
                                    discussions through the chat feature, their
                                    availability is not guaranteed 24/7. Users
                                    acknowledge that response times may vary
                                    depending on factors such as demand,
                                    workload, and time zone differences related
                                    to the Organizer of the Wellness program/the
                                    Authorized personnel. User acknowledge that
                                    the Application and the Provider are not
                                    responsible to ensure the availability of
                                    the Organizer of the Wellness program/the
                                    Authorized personnel.
                                </Paragraph>
                                <Paragraph>
                                    Users acknowledge that the Chat feature may
                                    not function at all time, may not function
                                    properly, and/or may not be suitable mean of
                                    communication with the Authorized personnel,
                                    therefore it is Users sole responsibility to
                                    determine whether to communicate with the
                                    Authorized personnel using the Chat feature
                                    and or use the Chat feature.
                                </Paragraph>
                                <Paragraph>
                                    Users acknowledge that the Chat feature is
                                    not and it is not intended to replace
                                    in-person medical consultations or emergency
                                    services. In cases of medical emergency, the
                                    User shall immediately contact medical
                                    institutions and/or medical professionals.
                                </Paragraph>
                                <Paragraph>
                                    The Application and the Provider disclaims
                                    any warranties or representations regarding
                                    the accuracy, completeness, or suitability
                                    of the information exchanged through the
                                    Chat feature. The Provider does not have
                                    access and/or control over the messages sent
                                    or received through the Chat feature, and
                                    does not endorse or guarantee the accuracy,
                                    reliability, or appropriateness of such
                                    messages. Users are encouraged to exercise
                                    caution and seek appropriate medical advice
                                    from qualified healthcare professionals for
                                    any specific health concerns or emergencies.
                                </Paragraph>
                                <Paragraph>
                                    Under no circumstances shall the Provider be
                                    liable for any damages, losses, or
                                    liabilities arising from the content,
                                    accuracy, or consequences of messages sent
                                    or received by Users through the Chat
                                    feature. Users expressly release the
                                    Provider from any claims, demands, or causes
                                    of action resulting from their use of the
                                    Chat feature and agree to indemnify and hold
                                    the Provider harmless from any claims,
                                    damages, or liabilities related to such
                                    messages, including the User’s use or
                                    interpretation of those messages, and/or the
                                    receipt or non-receipt of such messages by
                                    the User.
                                </Paragraph>
                            </li>

                            <Paragraph></Paragraph>
                            <Paragraph></Paragraph>
                        </ul>
                    </li>
                    <li>
                        <Strong>
                            2.1. DATA DEPENDENCY ON EXTERNAL DEVICES{' '}
                        </Strong>
                        <Paragraph>
                            Users acknowledge that the transferred to the
                            Application User’s Wellness Data comes from external
                            tracking devices – Smart wearables. Smart wearables
                            are either provided to the Users by the Organizer of
                            the Wellness program, or the Users use their own
                            Smart wearable devices. Therefore, Users acknowledge
                            and agree that the Provider does not bear any
                            responsibilities for the Smart wearables and does
                            not provide any maintenance and support services for
                            the Smart wearables. Any maintenance services (such
                            as troubleshooting, technical issues, repairs and/or
                            replacements) for the Smart wearables, are provided
                            by the respective Organizer of the Wellness program
                            or by third parties, as agreed between the Users and
                            the Organizer of the Wellness program. Users shall
                            cooperate with Organizer of the Wellness Program in
                            troubleshooting and resolving any device-related
                            issues in a timely manner.
                        </Paragraph>
                        <Paragraph>
                            Users acknowledge that the accuracy, reliability,
                            and availability of their data are dependent on the
                            proper functioning of the Smart wearables and their
                            compatibility with the Application. Users
                            acknowledge and agree that the Provider and/or the
                            manufacturer of the Smart wearables cannot and does
                            not guarantee that the Smart wearables provided to/
                            used by the Users are compatible with the
                            Application, or that they function properly with the
                            Application.
                        </Paragraph>
                        <Paragraph>
                            Users are responsible for the proper use, care and
                            protection of any Smart wearable devices they use
                            (in case Users use their own devices) or provided to
                            them by the Organizer of the Wellness Program and/or
                            by third party, for the purposes of participating in
                            the Wellness program. This include proper use and
                            handling, as well as safeguarding the Smart wearable
                            from damage, loss, theft, or unauthorized use. Users
                            shall report any issues or malfunctions with the
                            Smart wearables to the Organizer of the Wellness
                            program or to the third parties, as agreed between
                            the Users and the Organizer of the Wellness program.
                            In addition, Users shall follow any instructions or
                            guidelines provided by the manufacturer of the Smart
                            wearables, and/or the Organizer of the Wellness
                            Program, for the proper use and maintenance of the
                            Smart wearables, including but not limited to
                            instruction for use, charging procedures, storage
                            recommendations, and software updates. Such
                            instructions and guidelines may include avoiding
                            exposure to extreme temperatures, moisture, dust, or
                            other environmental hazards that may affect the
                            functionality of the Smart wearable.
                        </Paragraph>
                        <Paragraph>
                            Users acknowledge and agree that failure to adhere
                            to the above- mentioned usage and protection
                            obligations in relation to the Smart wearables, and
                            or to any use instructions and guidelines pertaining
                            to the use of the Smart wearable/s, may impact the
                            functionality and performance of the Smart
                            wearable/s and thus, the accuracy and completeness
                            of the displayed on the Application Users’ data,
                            and/or may lead to false Users’ Data and/or loss of
                            Users’ Data.{' '}
                        </Paragraph>
                        <Paragraph>
                            Users agree to indemnify and hold harmless the
                            Provider/the Organizer of the Wellness program
                            and/or the manufacturer of the Smart wearables from
                            any claims, damages, liabilities, or expenses
                            arising from the use or malfunction of the provided
                            Smart wearables, including but not limited to
                            damages to property, personal injury, or loss of
                            data. Users understand that they assume all risks
                            associated with the use of the Smart wearables and
                            agree to use them responsibly and in accordance with
                            the manufacturer and/or the Organizer of the
                            Wellness program 's instructions and guidelines.{' '}
                        </Paragraph>
                        <Paragraph>
                            Users acknowledge and agree that they are solely
                            responsible for ensuring the proper operation and
                            maintenance of the Smart wearables and for verifying
                            the accuracy and reliability of the data collected
                            by the Smart wearables. Users are encouraged to
                            consult with qualified healthcare professionals for
                            personalized advice and interpretation of their
                            Wellness Data transmitted by the Smart wearables.
                            The Application and the Provider shall not be liable
                            for any damages, losses, or liabilities arising from
                            reliance on the data transmitted and/or provided by
                            the Smart wearables and/or displayed on the Users
                            Application Account. Users agree that the Provider
                            and/or the manufacturer of the Smart wearables do
                            not bear any responsibilities in relation to User’s
                            use and/or handling of the Smart wearables, and
                            Users agree to indemnify and hold harmless the
                            Provider and/or the manufacturer of the Smart
                            wearables from any claims, damages, or liabilities
                            arising from their use and/or handling of the Smart
                            wearables.{' '}
                        </Paragraph>
                    </li>
                </ul>
            </Section>
            <Section title="IV. Eligibility">
                <Paragraph>
                    In order to use the Application and the Services, the User
                    must be at least 18 years of age (or the applicable age to
                    enter into legally binding contracts as established by User
                    country of registration). By accepting this Agreement, Users
                    declare and guarantee that they are at legal age and possess
                    legal capacity to enter into contracts that give rise to
                    obligations for them, as well as that all information
                    provided by them, for accessing their Account on the
                    Application, and when using the Application, is accurate,
                    true and provided entirely voluntarily.
                </Paragraph>
                <Paragraph>
                    The Provider is entitled, at its own discretion, to deny
                    access to the Application to any User who does not meet the
                    above criteria. The Application is not available to
                    Application Users whose access has been suspended or
                    restricted due to non-compliance with this Agreement. The
                    right to access the Application and the Services is revoked
                    where this Agreement or use of the Application and/or the
                    Services is prohibited or to the extent offering or
                    provision of the Services conflicts with any applicable law,
                    rule or regulation.
                </Paragraph>
            </Section>
            <Section title="V. Wellness Program">
                <Paragraph>
                    The access and use of the Application and the Services it
                    offers are exclusively reserved to Users participating in a
                    specific Wellness Program. By participating in the Wellness
                    Program Users will gain access to the abovementioned in
                    Section III, point 2 features of the Application aimed at
                    enhancing Users Wellness Program’ experience.
                </Paragraph>
                <Paragraph>
                    In order for the User to join the Wellness Program, and
                    prior to be accepted as participant, User should first
                    undergo a clinical assessment with a medical professional.
                    This sets a baseline set of parameters that help measure
                    Users’ state of wellness, as well as determined the level of
                    fitness and capability of the User to undertake the
                    activities part of the Wellness Program. It also enables the
                    engaged medical professionals to recognize whether Users
                    have any predetermining health condition that might put them
                    at risks, and whether some activity may not be advisable and
                    should be avoided by the Users. The clinical assessment is
                    performed and organized solely by the respective Organizer
                    of the Wellness Program/Authorized Personnel, and Users
                    acknowledge and agree that the Provider does not participate
                    or contribute in any way to such clinical assessments.
                </Paragraph>
                <Paragraph>
                    All conditions related to the participation of the User in
                    the specific Wellness Program are set out by the respective
                    Organizer of the Wellness Program. Should the Users need any
                    guidance, training or other kind of assistance in terms of
                    the specific Wellness Program, they shall revert to the
                    respective Organizer of the Wellness Program.{' '}
                </Paragraph>
                <Paragraph>
                    Users acknowledge and agree that the Provider is not
                    involved in the organization of the Wellness Programs, that
                    the Provider does not participate in any criteria or
                    parameters established for participation in the Wellness
                    Program, therefore the Provider do not bear any
                    responsibilities in terms of acceptance or non-acceptance of
                    specific individuals to the Wellness Program. In addition,
                    the Authorized Personnel that are designated to monitor the
                    wellness indicators and activities of the User, are
                    appointed solely by the respective Organizer of the Wellness
                    Program, and the Application and the Provider are not
                    responsible in any way for their appointment, competence and
                    quality of services provided by them to the Users.{' '}
                </Paragraph>
            </Section>
            <Section title="VI. User Responsibilities">
                <Strong>Registration </Strong>
                <Paragraph>
                    Only individuals who are participants in the Wellness
                    Program have the right to access and use the Application and
                    the Services. In order to use the Application and the
                    Services, User shall:
                </Paragraph>{' '}
                <List
                    items={[
                        `undergo a clinical assessment for the purpose of participating in the Wellness program and shall be registered in a Wellness program. `,
                        `have a legally binging agreement with the Organizer of the Wellness Program that allows the User to participate in the Wellness Program and use the Application and the Services in this regard,`,
                        `agree to this Agreement and Privacy Policy; `,
                    ]}
                    type={'lower-alpha-list'}
                />
                <Paragraph>
                    User’s Account on the Application is created after the User
                    concluded legally binding Agreement with the Organizer of
                    the Wellness Program for participation to the Wellness
                    Program and once the User complete the clinical assessment,
                    organized and performed by the Organizer of the Wellness
                    Program. Users may access their Accounts provided that they
                    agreed to this Agreement and Privacy Policy.
                </Paragraph>{' '}
                <Paragraph>
                    For the purpose of registering in the Application, all Users
                    must provide the Organizer of the Wellness Program with
                    certain identification information, which may include their
                    full name, email address, and other relevant details. Users
                    agree to submit true, accurate, and complete information and
                    to keep their account details current and up-to-date.{' '}
                </Paragraph>
                <Paragraph>
                    A username and other credentials for accessing the
                    Application will be automatically generated and sent to the
                    email address provided by the User during the onboarding
                    process conducted by the Organizer of the Wellness Program.
                    Users are responsible for providing a valid email address
                    and other contact details to the Organizer of the Wellness
                    Program. Upon their first login to the Application, Users
                    will be required to change their automatically generated
                    password to a new, personalized password.{' '}
                </Paragraph>
                <Paragraph>
                    All Users declares and guarantees that possess legal
                    capacity, that have no other registration in the
                    Application, that the information entered by them for
                    providing access to their Account, and when using the
                    Application, is and will be true and corresponds to reality.{' '}
                </Paragraph>
                <Paragraph>
                    In case another person (Authorized Individuals) is allowed
                    and required to access User’s Account or add information on
                    behalf of that User, that person must first obtain the
                    written permission of the User, and subsequently request
                    from the Organizer of the Wellness Program to provide them
                    with their own distinct credentials and registration to
                    access the User’s Account.{' '}
                </Paragraph>
                <Paragraph>
                    In order to access the Application, it is necessary for the
                    User to have a device compatible with the Application. The
                    Provider of the Application does not guarantee that the
                    Application is compatible with the device used by the User.
                    Users’ devices must meet the following technical
                    requirements to be able to use the Application:{' '}
                </Paragraph>
                <ul className="">
                    <li>
                        For Apple devices (iPhones and iPads): Version iOS 15 or
                        later version;{' '}
                    </li>
                    <li>
                        For Android devices: Android Version 12 or later
                        version;{' '}
                    </li>
                    <li>{`PC: Windows 10: 22H2 (2022), 21H2 (2021), 21H1 (2021) / Windows 11: 23H2 (2023), 22H2 (2022), 21H2 (2021); macOS: macOS Sonoma: Version 14 (2023), macOS Ventura: Version 13 (2022), macOS Monterey: Version 12 (2021); `}</li>
                    <li>Internet connection. </li>
                </ul>
                <Strong>Use of the Application and the Services </Strong>
                <Paragraph>
                    By accepting this Agreement, the Provider grants the Users
                    license to use the Application only for personal and
                    non-commercial purposes. With the granted license to use the
                    Application, the Provider does not transfer to the Users any
                    ownership rights to the Application, the software or its
                    content, and according to the granted license to use, the
                    User is expressly prohibited to:
                </Paragraph>
                <List
                    items={[
                        `modify or copy the software or content of the Application; `,
                        `use the Application, software and Application content for commercial purposes or publicly distribute it; rent, lease, lend, sell, transfer, redistribute, or sublicense the Application, software and Application content; `,
                        `decompile, reverse-engineer, disassemble, attempt to derive the source code of, modify, or create derivative works of the Application, software and Application content, or any part thereof; `,
                        `remove any copyright or other intellectual property notices from the content or software of the Application or transfer the content to another person or copy the content or software to another server. `,
                        `collect usernames and/or email addresses of other Users by electronic or any other means for any purpose; `,
                        `use of web scraping, web harvesting, or web data extraction methods from the Application; `,
                        `upload viruses or malicious code, use the Application and the Services to send spam, or do anything else that could disable, overburden, interfere with, or impair the proper working, integrity, operation, or appearance of the Application and the Services; `,
                        `interfere with or disrupt the Application or servers or networks, or disobey any requirements, procedures, policies or regulations of networks connected with the Application and the Services; `,
                        `interfere with, disrupt or circumvent any security feature of the Application or any feature that restricts or enforces limitations on use of or access to the Application; `,
                        `use the Application to violate the law; `,
                        `use the Application to harm minors in any way; `,
                        `use the Application to reveal and/or share any personal information about another individual, including any information that may be used to track, contact or impersonate that individual; `,
                        `defraud or mislead the Provider/the Authorized Personnel/the Organizer of the Wellness Program or other Users; `,
                        `create an Application account by automated means or false pretenses or use any other User’s account for any purpose, including to circumvent a suspension or ban; `,
                    ]}
                    type={'lower-alpha-list'}></List>
                <Paragraph>
                    Any attempt to violate the above-mentioned prohibitions
                    constitutes a breach of this Agreement by the User, and may
                    result in legal action, including prosecution and claims for
                    damages. Furthermore, Users acknowledge and agree that any
                    such breach may lead to the removal, restriction, or
                    blocking of their Account on the Application.{' '}
                </Paragraph>
                <Paragraph>
                    In addition, the Provider reserves the right to refuse
                    registration and/or disable a User Account, as well as to
                    suspend access to the Application and the ability to use it
                    in the following cases: there is information that the
                    respective User's use of the Application is prohibited by
                    law; there is information that the User has violated in the
                    past or is currently violating this Agreement; there is a
                    suspicion of illegal activity by the User on the
                    Application.
                </Paragraph>
                <Paragraph>
                    Unauthorized access to the Application, including but not
                    limited to unauthorized access to the information systems or
                    databases of the Application, unregulated use of and in
                    connection with the Application are strictly prohibited.
                    Users agree that they will not access the Application
                    without authorization, and will not use the Application in
                    any way contrary to this Agreement and the applicable
                    legislation, otherwise they will be responsible for the
                    direct and indirect damages caused to the Provider, other
                    Users, and/or to third parties. In the cases in the previous
                    sentence, the User is obliged to fully compensate the
                    Provider, other Users, and/or affected parties of all
                    damages caused.
                </Paragraph>
                <Paragraph>
                    Users of the Application accept that upon deactivation of
                    their User’s Account, the information from the deactivated
                    account could be stored for a certain period of time in
                    accordance with the applicable legislation, sufficient to
                    ensure the possibility of providing this information upon
                    due request by government authorities and authorized third
                    parties. The information can be used to prove the
                    fulfillment of contractual obligations of the Provider, the
                    Organizer of the Wellness Program and/or other Users and
                    third parties, to resolve legal disputes, prevent fraud,
                    protect the Provider, the Organizer of the Wellness Program,
                    other Users and third parties from illegal actions and
                    damages, as well as in order to comply with applicable
                    legislation and the internal Security policy of the Provider
                    and the Application.
                </Paragraph>
                <Paragraph>
                    In case a User sees content on the Application that the User
                    considers illegal, the User shall report it directly to the
                    Organizer of the Wellness program, as agreed between the
                    User and the Organizer of the Wellness Program.
                </Paragraph>
            </Section>
            <Section title="VII. User Responsibilities">
                <Paragraph>
                    Users acknowledge that they are solely responsible and
                    liable for their use of the Application and the Services,
                    directly or indirectly, including understanding whether such
                    access or use is permitted by or in violation of this
                    Agreement. Users are further solely responsible for
                    compliance with all applicable laws relating to their use of
                    the Application and the Services. Users shall further use
                    the Application and the Services solely for lawful purposes,
                    and shall conduct all activities through the Application and
                    the Services in accordance with all applicable laws and
                    regulations.
                </Paragraph>

                <Paragraph>
                    Users are responsible for ensuring and maintaining that they
                    are able to access and use the Application and the Services,
                    including by securing their own compatible hardware,
                    internet access, security mobile apps, and any other
                    requirement. The Provider shall have no responsibility to
                    provide any applications or any hardware. Users further
                    agree that the Provider shall have no responsibility for any
                    data loss or other damage or loss suffered in connection
                    with their use of the Application and the Services,
                    including any failure to provide adequate security or backup
                    devices or services.
                </Paragraph>

                <Paragraph>
                    Users are responsible for ensuring that the Organizer of the
                    Wellness Program has accurate and current information for
                    their Accounts, including current contact information. When
                    User is provided with a username, password, credentials
                    file, or any other piece of information as part of any
                    security procedure (“Credentials”), User must treat such
                    information as confidential, and must not disclose
                    Credentials to any other person or entity. Users acknowledge
                    that their Account and Credentials are personal to them, and
                    further agree not to provide any other person with access to
                    the Application and the Services or portions of the
                    Application and the Services using their username, password,
                    or other security information. Users shall notify the
                    Organizer of the Wellness Program immediately of any
                    unauthorized access to or use of their Credentials or any
                    other breach of security. In such cases, after confirmation
                    from the Organizer of the Wellness Program, the Provider is
                    entitled to disable any username, password, credentials
                    file, or other identifier, whether chosen by the User or
                    provided by the Organizer of the Wellness Program.
                </Paragraph>

                <Paragraph>
                    Users are responsible for ensuring and maintaining that they
                    are able to participate in the Wellness Program and that
                    they can use the Application and the Services. Prior to
                    joining the chosen Wellness Program, the User is obliged to
                    undergo a health consultation with a clinical professional,
                    as described in Section V above, as well as to have a
                    legally binding agreement with the Organizer of the Wellness
                    Program that allows the User to use the Application and the
                    Services.
                </Paragraph>

                <Paragraph>
                    Users acknowledge and agree that they have a duty of care to
                    themselves while participating in the Wellness Program and
                    while using the Application and the Services in this regard.
                    Users acknowledge and agree that they are ultimately
                    responsible for their own health and well-being during the
                    Wellness Program, and during any time they use the
                    Application and the Services. Users acknowledge that they
                    must take an active role in managing their health and making
                    informed decisions that align with their individual needs
                    and circumstances. Users acknowledge that the Application,
                    the Services, and the participation in the specific Wellness
                    Program, are not a substitute for professional medical
                    advice, diagnosis, or treatment. Users are encouraged to
                    consult with qualified healthcare providers for personalized
                    medical advice and recommendations tailored to their
                    specific wellness and health concerns, medical history, and
                    individual needs.
                </Paragraph>

                <Paragraph>
                    Users acknowledge and accept that participation in the
                    Wellness Program, and using the Application and Services in
                    this regard, may involve inherent risks (which may include
                    risks associated with physical activity, dietary changes,
                    treatments). By voluntarily participating in the Wellness
                    Program, Users assume full responsibility for any risks,
                    injuries, or adverse outcomes that may result from their
                    participation in the Wellness Program, and usage of the
                    Application and the Services in this regard, and hereby
                    release the Application and the Provider from any liability
                    arising therefrom.
                </Paragraph>
            </Section>
            <Section title="VIII. Data protection. Security and protection of data">
                <Paragraph>
                    In order to use the Application, Users are provided with
                    User Accounts described above in this Agreement. In order to
                    complete their User profile and to use the Application,
                    Users are required to provide certain personal data to the
                    Organizer of the Wellness Program.
                </Paragraph>

                <Paragraph>
                    As part of the creation process of User’s profile, Users
                    consent to the Application processing their personal data
                    (as described in this Agreement and the Privacy Policy).
                </Paragraph>

                <Paragraph>
                    The Application may transfer various types of data from
                    Users, including but not limited to personal data,
                    wellness-related data, Smart wearable information, and usage
                    data.
                </Paragraph>

                <Paragraph>
                    All User’s Data is secured, held in an encrypted database
                    that only the User, the Organizer of the Wellness
                    Program/the Authorized Personnel will have access to. The
                    Provider of the Application does not have access to the
                    Users' personal data. The Application does not access and/or
                    store User Data transmitted through it. Only the User, the
                    Hospital, and the Authorized Personnel have access to the
                    User’s Data transferred through the Application and only the
                    User, the Hospital, and the Authorized Personnel have the
                    right to review, analyze, amend, or edit it.
                </Paragraph>

                <Paragraph>
                    The transmission of data between the Smart wearables and the
                    Application is also encrypted. In addition, there is no
                    human identifiable data held on the Smart wearables, this is
                    to protect the User should the Smart wearable device become
                    lost or stolen. The ID numbers that are system generated to
                    link the Smart wearable devices to the Application have no
                    smart identification behind them, and they contain random
                    numbers.
                </Paragraph>

                <Paragraph>
                    The Application implements strict security measures to
                    protect the confidentiality, integrity, and availability of
                    Users' data. These measures may include encryption, access
                    controls, and regular security audits. However, users
                    acknowledge that no security measures are foolproof, and the
                    Application cannot guarantee the absolute security of Users'
                    Data against unauthorized access, disclosure, or alteration.
                </Paragraph>

                <Paragraph>
                    Additional information regarding the collection and
                    processing of personal data of Users, as well as their
                    rights in terms of their data, is contained in the Privacy
                    Policy, an integral part of this Agreement. By accessing or
                    using the Application, Users acknowledge that they have
                    read, understood, and agreed to the terms of this Privacy
                    Policy and consent to the processing of their data as
                    described therein.
                </Paragraph>
            </Section>
            <Section title="IX. Intellectual Property">
                <Paragraph>
                    The rights to the name, trademark and logo of the
                    Application and the Provider, as well as all intellectual
                    property rights in relation to the Application, the
                    software, including parts of it, its content, data files or
                    other materials and objects of intellectual property to
                    which the Users have access to when using the Application
                    and the Services, are the exclusive property of the
                    Provider. The content of the Application is protected by the
                    applicable legal acts in the field of copyright, patent,
                    trademark and other intellectual property laws, and the same
                    is the property of the Provider or is used by the Provider
                    according to a license or permission obtained, and the Users
                    may not use it contrary to the provisions of this Agreement.
                </Paragraph>

                <Paragraph>
                    Application content includes, but is not limited to, all
                    text, formatting, selection, design of the Application,
                    images, graphics, tools, textual content, photographic
                    images, videos, trademarks (including those claimed to be in
                    the process of being registration), trade names, logos, as
                    well as other materials and information contained in the
                    Application.
                </Paragraph>

                <Paragraph>
                    Software, computer code, executable code, technology, and
                    other content and materials included in the Application,
                    including, without limitation: text, design, user
                    interfaces, button icons, communications programs, images,
                    photographs, audio clips, video clips, digital downloads,
                    and data is owned exclusively by the Provider or its
                    licensors and protected by applicable copyright, patent,
                    trademark and other intellectual property laws. Except for
                    the limited license to use the Application as expressly set
                    forth herein, the Provider grants no other rights, license
                    or interest in or to the Application or its related
                    intellectual property rights and ownership, all of which are
                    expressly reserved by the Provider.
                </Paragraph>

                <Paragraph>
                    The Application and Services may also contain or refer to
                    third-party trademarks, trade names, product names, and
                    logos that may be registered trademarks of their respective
                    owners. Under no circumstances Users may use or copy any of
                    the trademarks, trade names, product names, and logos.
                    Nothing herein should be construed as granting the User
                    license or right to use any trademarks, trade names, product
                    names, and logos displayed in connection with the Services
                    without Provider's express written permission.
                </Paragraph>

                <Paragraph>
                    If Users provide any communications or materials to the
                    Provider by mail, email, telephone, or otherwise, suggesting
                    or recommending changes to the Application and/or Services,
                    including without limitation, new features or functionality
                    relating thereto, or any comments, questions, suggestions
                    (herein refer to as “Feedback”), the Provider is free to use
                    such Feedback irrespective of any other obligation or
                    limitation between the parties governing such Feedback. The
                    Provider is free to use, without any attribution or
                    compensation to any party, any ideas, know-how, concepts,
                    techniques, or other intellectual property rights contained
                    in the Feedback, for any purpose whatsoever, although the
                    Provider is not required to use any Feedback.
                </Paragraph>
            </Section>
            <Section title="X. User Submissions">
                <Paragraph>
                    The Application may include functionality to permit the
                    Users to submit content for viewing by one or more users,
                    whether manually at the direction of Users of the Services
                    or automatically in accordance with User Account settings
                    and the hosting, sharing, and/or publishing of such (“User
                    Submissions”). Users warrant and represent that all User
                    Submissions provided by them are in compliance with all
                    applicable laws, rules and regulations. The Provider has no
                    obligation to accept, display, review, maintain or otherwise
                    exploit any User Submissions.
                </Paragraph>

                <Paragraph>
                    Users are solely responsible for their User Submissions and
                    the consequences of posting or publishing such. In
                    connection with any made by the Users User Submissions,
                    Users affirm, represent, and/or warrant that: (i) they own
                    or have the necessary licenses, rights, consents, and
                    permissions to use and authorize the Provider to use all
                    patent, trademark, trade secret, copyright or other
                    proprietary rights in and to any and all User Submissions to
                    enable inclusion and use of the User Submissions in the
                    manner contemplated by the Services and this Agreement; and
                    (ii) they have the express specific, informed and
                    unambiguous consent, release, and/or permission of each and
                    every identifiable individual person in the User Submission
                    to use the name or likeness of each and every such
                    identifiable individual person to enable inclusion and use
                    of the User Submissions in the manner contemplated by the
                    Services and this Agreement.
                </Paragraph>

                <Paragraph>
                    By submitting User Submissions to the Application, Users
                    grant, or warrant that they and/or the owner of such
                    material has expressly granted, the Provider the
                    royalty-free, perpetual, irrevocable, non-exclusive right
                    and license to use, reproduce, modify, adapt, publish,
                    translate, and distribute such material (in whole or in
                    part) worldwide and/or to incorporate it in other works in
                    any form, media, or technology now known or hereafter
                    developed for the full term of any copyright or other rights
                    that may exist in such material. Users will be solely liable
                    for any damage resulting from any defamation, infringement
                    of copyrights, proprietary rights, or any other harm or
                    claim resulting from a User Submission.
                </Paragraph>

                <Paragraph>
                    To the extent User Submissions contains personal data (as
                    defined by the EU General Data Protection Regulation and/or
                    the UK General Data Protection Act), the foregoing license
                    is subject to the Privacy Policy. If Users use of the
                    Services is on behalf of or managed by a clinical
                    representative, organizing body or other entity Users are
                    affiliated with (“Managing Entity”), this User Submissions
                    may also be shared with that entity or other organization as
                    more fully described in the Privacy Policy. Users consent to
                    that sharing and acknowledge and agree that the Provider is
                    not responsible for any use or disclosure of Users
                    information by that Managing Entity. The Provider may
                    maintain copies of any User Submissions for purposes of
                    backup, security, or maintenance, or as required by law.
                </Paragraph>

                <Paragraph>
                    In connection with User Submissions, Users further agree
                    that they will not: (i) submit material that is copyrighted,
                    protected by trade secret or otherwise subject to third
                    party proprietary rights, including privacy and publicity
                    rights, unless Users are the owner of such rights or have
                    permission from their rightful owner to post the material
                    and to grant the Provider all of the license rights granted
                    herein; (ii) publish falsehoods or misrepresentations that
                    could damage the Provider or any third party; (iii) submit
                    material that is unlawful, obscene, defamatory, libelous,
                    threatening, pornographic, harassing, hateful, racially or
                    ethnically offensive, or encourages conduct that would be
                    considered a criminal offense, give rise to civil liability,
                    violate any law, or is otherwise inappropriate; (iv) post
                    advertisements or solicitations of business; or (v)
                    impersonate another person. In the cases listed in the
                    preceding sentence, such User Submissions shall be removed,
                    and/or User’s access to the Application may be terminated,
                    pursuant to the rules of Section XI below.
                </Paragraph>

                <Paragraph>
                    The Provider does not endorse any User Submissions, or any
                    opinion, recommendation, or advice expressed therein, and
                    the Provider expressly disclaim any and all liability in
                    connection with any User Submissions. The Application and
                    the Provider do not permit copyright infringing activities
                    and infringement of intellectual property rights in
                    connection with the Application and the Services, and the
                    Provider will remove, pursuant to the rules of Section XI
                    below, all content and User Submissions if properly notified
                    that such content or User Submissions infringes on another’s
                    intellectual property rights. The Provider may also
                    terminate Users access to the Services if they are
                    determined to be a repeat infringer. A repeat infringer is
                    anyone who has been notified of infringing activity more
                    than once and/or has had any User Submissions removed from
                    the Application and the Services more than twice.
                </Paragraph>

                <Paragraph>
                    In case a User sees content on the Application that the User
                    considers illegal, the User shall report it directly to the
                    Organizer of the Wellness Program, as agreed between the
                    User and the Organizer of the Wellness Program.
                </Paragraph>
            </Section>
            <Section title="XI. ENFORCEMENT OF THIS AGREEMENT">
                <Paragraph>
                    The Provider may take any of the following actions to
                    enforce this Agreement:
                </Paragraph>
                <List
                    items={[
                        `Remove or refuse to display User-submitted content (User Submissions under Section X above) that violates the rules of Sections VI, VII, IX and X above; `,
                        `Limit the dissemination and/or visibility of certain User-submitted content (User Submissions under Section X above); `,
                        `Suspend or terminate the User Account `,
                        `Assert its rights in court based on a breach of this Agreement or other cause of action. `,
                    ]}
                />
                <Paragraph>
                    Although the Provider endeavor to enforce this Agreement
                    consistently, the Provider disclaim, to the fullest extent
                    permitted by applicable law, any obligation or
                    responsibility to moderate User Submissions.
                </Paragraph>
                <Paragraph>
                    In addition, the Provider reserves the right to update,
                    modify or delete any information, content, features or
                    Services, contained in the Application at any time and
                    without the need for prior notice, unless such is mandatory
                    under applicable law, without thereby assuming any liability
                    in relation to it.{' '}
                </Paragraph>
            </Section>
            <Section title="XII. WARRANTIES DISCLAIMER">
                <strong>
                    <Paragraph>
                        THE APPLICATION AND THE SERVICES ARE PROVIDED TO USERS
                        ON “AS IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTY OF
                        ANY KIND, AND THE PROVIDER AND ITS SUBSIDIARIES,
                        AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES,
                        REPRESENTATIVES, AGENTS, PARTNERS, AND LICENSORS HEREBY
                        DISCLAIM ALL WARRANTIES AND CONDITIONS WITH RESPECT TO
                        THE APPLICATION AND THE SERVICES WHETHER EXPRESS OR
                        IMPLIED AND EXPRESSLY DISCLAIMS ANY IMPLIED WARRANTIES
                        OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR
                        PURPOSE, SATISFACTORY QUALITY, AND NON-INFRINGEMENT. THE
                        PROVIDER DOES NOT WARRANT AGAINST INTERFERENCE WITH USER
                        ENJOYMENT OF THE APPLICATION AND THE SERVICES, THE
                        AVAILABILITY OF CONTENT, THAT THE FUNCTIONS CONTAINED IN
                        THE APPLICATION AND THE SERVICES WILL MEET USER
                        REQUIREMENTS, THAT THE APPLICATION AND THE SERVICES WILL
                        BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, THAT THE
                        OPERATION OF THE APPLICATION AND THE SERVICES WILL BE
                        UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS IN THE
                        APPLICATION AND THE SERVICES WILL BE CORRECTED, OR THAT
                        THE FUNCTIONS CONTAINED IN THE APPLICATION AND THE
                        SERVICES WILL FUNCTION WITH MOBILE APPS OR HARDWARE, OR
                        WITHIN A SYSTEM. NO ORAL OR WRITTEN INFORMATION OR
                        ADVICE GIVEN BY THE PROVIDER OR PROVIDER’S AUTHORIZED
                        REPRESENTATIVE SHALL CREATE A WARRANTY.
                    </Paragraph>

                    <Paragraph>NOT A MEDICAL SERVICE</Paragraph>

                    <Paragraph>
                        THE USERS OF THE APPLICATION ACKNOWLEDGE AND AGREE THAT
                        THE APPLICATION AND THE PROVIDER OF THE APPLICATION DO
                        NOT PROVIDE MEDICAL AND/OR WELLNESS SERVICES,
                        CONSULTATIONS, ANALYSIS, ADVICE OR RECOMMENDATIONS IN
                        ANY FORM. USERS ACKNOWLEDGE AND AGREE THAT THE PROVIDER
                        AND THE APPLICATION ARE NOT MEDICAL FACILITY OR
                        INSTITUTION, AND THAT THE ACTIVITY OF THE PROVIDER AND
                        THE SERVICES AVAILABLE ON THE APPLICATION ARE NOT
                        SUBJECT TO LICENSING, REGISTRATION, PERMIT REGIME OR
                        REGULATORY SUPERVISION.
                    </Paragraph>

                    <Paragraph>
                        THE USERS OF THE APPLICATION ACCEPT AND AGREE THAT THE
                        APPLICATION, THE SERVICES AND THEIR CONTENT, AS WELL AS
                        THE COMMUNICATION IN CONNECTION WITH THE FUNCTIONING OF
                        THE SAME, RESPECTIVELY IN CONNECTION WITH THE USE OF THE
                        APPLICATION AND THE SERVICES, DO NOT CONSTITUTE MEDICAL
                        SERVICES, CONSULTATIONS, ANALYSIS, ADVICE OR
                        RECOMMENDATIONS IN ANY FORM, AND SUCH ARE NOT PROVIDED
                        AND/OR OFFERED BY THE PROVIDER AND THE APPLICATION.
                    </Paragraph>

                    <Paragraph>
                        THE APPLICATION AND THE SERVICES, INCLUDING ALL
                        INFORMATION, TEXT, PHOTOGRAPHS, IMAGES, ILLUSTRATIONS,
                        GRAPHICS, AUDIO, VIDEO, AND AUDIO-VIDEO CLIPS, AND OTHER
                        MATERIALS, WHETHER PROVIDED BY THE PROVIDER OR THIRD
                        PARTIES, ARE NOT INTENDED TO BE AND SHOULD NOT BE USED
                        IN PLACE OF (a) THE ADVICE OF A PHYSICIAN OR OTHER
                        MEDICAL PROFESSIONALS, (b) A VISIT, CALL, OR
                        CONSULTATION WITH PHYSICIAN OR OTHER MEDICAL
                        PROFESSIONALS, OR (c) INFORMATION CONTAINED ON OR IN ANY
                        PRODUCT PACKAGING OR LABEL.
                    </Paragraph>

                    <Paragraph>
                        USERS OF THE APPLICATION ACKNOWLEDGE THAT THE
                        APPLICATION IS NOT INTENDED TO BE AND MAY NOT BE USED TO
                        DETECT, DIAGNOSE AND/OR TREAT MEDICAL OR HEALTH
                        PROBLEMS, NOR TO CONFIRM THE EXISTENCE OR ABSENCE OF
                        MEDICAL OR HEALTH PROBLEMS. THE PROVIDER ADVISES ITS
                        USERS TO CONSULT A PHYSICIAN OR OTHER QUALIFIED MEDICAL
                        PROFESSIONAL IF THEY HAVE ANY QUESTIONS ABOUT THEIR
                        HEALTH AND WELLNESS CONDITION, MEDICATION, THERAPY
                        AND/OR TREATMENT.
                    </Paragraph>

                    <Paragraph>
                        THE USERS OF THE APPLICATION ACCEPT AND AGREE THAT
                        SHOULD THEY HAVE ANY MEDICAL SITUATION, THEY SHOULD CALL
                        OR SEE THEIR PHYSICIAN OR MEDICAL PROFESSIONAL. SHOULD
                        AN EMERGENCY OCCUR, THE USER SHALL CALL MEDICAL
                        PROFESSIONALS OR THE RESPECTIVE LOCAL EMERGENCY
                        TELEPHONE NUMBER IMMEDIATELY. USERS ACKNOWLEDGE THAT
                        THEY SHOULD NEVER USE THE APPLICATION AND THE SERVICE IN
                        CASE OF EMERGENCY HEALTH CONDITIONS AND/OR OTHER
                        CONDITIONS IN WHICH THE DELAY IN THE TIME OF MEDICAL
                        ASSISTANCE, PROVIDED THROUGH A PRESENT CONTACT, WOULD
                        ENDANGER THEIR LIFE AND HEALTH, AS WELL AS WHEN THEY DO
                        NOT HAVE THE NECESSARY KNOWLEDGE REGARDING THE USE OF
                        THE APPLICATION AND THE SERVICES.
                    </Paragraph>

                    <Paragraph>
                        USERS SHOULD NEVER DISREGARD MEDICAL ADVICE OR DELAY IN
                        SEEKING MEDICAL ADVICE BECAUSE OF ANY INFORMATION
                        PRESENTED ON THE APPLICATION, AND SHOULD NOT USE THE
                        APPLICATION AND SERVICES OR ANY INFORMATION PROVIDED IN
                        THE APPLICATION FOR DIAGNOSING OR TREATING A HEALTH
                        PROBLEM. THE USERS OF THE APPLICATION ACCEPT AND AGREE
                        THAT THE TRANSMISSION AND RECEIPT OF THE SERVICES, IN
                        WHOLE OR IN PART, OR COMMUNICATION VIA THE APPLICATION
                        DOES NOT CONSTITUTE OR CREATE A DOCTOR-PATIENT, OR OTHER
                        HEALTHCARE PROFESSIONAL RELATIONSHIP BETWEEN THE USER
                        AND THE PROVIDER.
                    </Paragraph>

                    <Paragraph>NOT A MEDICAL DEVICE</Paragraph>

                    <Paragraph>
                        THE USERS OF THE APPLICATION ACCEPT AND AGREE THAT THE
                        APPLICATION AND THE SERVICES ARE NOT A MEDICAL DEVICE.
                        THE APPLICATION AND SERVICES ARE NOT INTENDED TO
                        DIAGNOSE, TREAT, CURE, OR PREVENT ANY DISEASE OR MEDICAL
                        CONDITION. THE APPLICATION AND SERVICES ARE FOR
                        INFORMATIONAL PURPOSES ONLY AND CANNOT REPLACE THE
                        SERVICES OF LICENSED PHYSICIANS OR MEDICAL
                        PROFESSIONALS.
                    </Paragraph>

                    <Paragraph>POTENTIAL RISKS</Paragraph>

                    <Paragraph>
                        THE CONTENT AVAILABLE THROUGH THE APPLICATION AND
                        SERVICES MAY INCLUDE WELLNESS INFORMATION,
                        RECOMMENDATIONS, AND OTHER TO HELP USERS MEET THEIR
                        WELLNESS GOALS. USERS ACKNOWLEDGE AND AGREE THAT THE
                        APPLICATION AND THE SERVICES (INCLUDING ANY
                        RECOMMENDATIONS AND ANY INFORMATION AVAILABLE THROUGH
                        THE APPLICATION AND THE SERVICES) MAY NOT BE APPROPRIATE
                        FOR EACH AND/OR ANY USER. THE PROVIDER IS NOT
                        RESPONSIBLE FOR ANY RESULTS THAT MAY OR MAY NOT BE
                        OBTAINED FROM THE USE OF THE APPLICATION, ITS CONTENT
                        AND THE SERVICES.
                    </Paragraph>

                    <Paragraph>
                        THE APPLICATION AND THE SERVICES PROVIDE REMOTE
                        TRANSFERRING OF WELLNESS DATA USING TELECOMMUNICATIONS
                        TECHNOLOGIES. USERS UNDERSTAND AND ACKNOWLEDGE THAT THE
                        APPLICATION AND THE SERVICES HAVE LIMITATIONS AND CANNOT
                        FULLY OR MAY NOT ACCURATELY REPRESENT THEIR WELLNESS
                        STATUS.
                    </Paragraph>

                    <Paragraph>
                        IN ADDITION, USERS ACKNOWLEDGE THAT THERE ARE POTENTIAL
                        RISKS AND LIMITATIONS ASSOCIATED WITH USE OF THE
                        APPLICATION AND THE SERVICES, INCLUDING BUT NOT LIMITED
                        TO:
                    </Paragraph>
                    <List
                        items={[
                            `INACCURACIES OR ERRORS IN DATA TRANSMISSION OR INTERPRETATION; `,
                            `INTERRUPTIONS, DELAYS, OR FAILURES IN TELECOMMUNICATION SYSTEMS OR EQUIPMENT; `,
                            `SECURITY RISKS ASSOCIATED WITH TRANSMITTING WELLNESS DATA OVER THE INTERNET OR OTHER COMMUNICATION NETWORKS, INCLUDING BUT NOT LIMITED TO: UNAUTHORIZED ACCESS, INTERCEPTION, OR DATA BREACHES; `,
                            `RISKS ASSOCIATED WITH ТHE SPECIFIC TYPE AND MODEL OF THE SMART WEARABLE DEVICE USED; RISKS ASSOCIATED WITH USER USE OF THE SMART WEARABLE AND USER COMPLIANCE WITH INSTRUCTIONS OF USE; ENVIRONMENTAL CONDITIONS; `,
                            `RISKS ASSOCIATED WITH ТHE SPECIFIC SCOPE OF TRANSMETTED DATA AND POSSIBLE MONITORING. USERS ACKNOWLEDGE THAT THE APPLICATION AND THE SERVICES CANNOT CAPTURE ALL ASPECTS OF USER WELLNESS STATUS, OR USER CONDITION. USERS ACKNOWLEDGE THAT THE INFORMATION PROVIDED BY THE SMART WEARABLES AND VISIBLE IN THE APPLICATION MAY BE MISLEADING IF THEIR PHYSIOLOGICAL FUNCTIONS AND RESPONSES DIFFER SIGNIFICANTLY FROM POPULATION AVERAGES DUE TO MEDICAL CONDITIONS OR UNIQUE INDIVIDUAL VARIATIONS. `,
                        ]}
                        type={'lower-alpha-list'}
                    />
                </strong>
                <Strong>THE LIMITED ROLE OF THE APPLICATION PROVIDER</Strong>
                <Paragraph>
                    USERS ACKNOWLEDGE AND AGREE THAT THE PROVIDER OF THIS
                    APPLICATION SERVES SOLELY AS THE LICENSOR, GRANTING
                    APPLICATION USAGE RIGHTS TO THE ORGANIZER OF WELLNESS
                    PROGRAM/ THE MEDICAL PRACTITIONERS, AND THE USERS. THE
                    DECISION TO PROVIDE ACCESS TO THIS APPLICATION, INCLUDING
                    THE TERMS AND CONDITIONS UNDER WHICH IT IS OFFERED BY THE
                    ORGANIZER OF THE WELLNESS PROGRAM, ARE MADE EXCLUSIVELY BY
                    THE ORGANIZER OF THE WELLNESS PROGRAM WITH WHOM USERS ARE
                    AFFILIATED. THE APPLICATION PROVIDER DOES NOT ENGAGE IN USER
                    SELECTION OR CARE DECISIONS.
                </Paragraph>

                <Paragraph>
                    USERS ACKNOWLEDGE AND AGREE THAT THEIR USE OF THIS
                    APPLICATION AND SERVICES ARE CONTINGENT UPON THEIR
                    RELATIONSHIP WITH THE ORGANIZER OF WELLNESS PROGRAM/MEDICAL
                    PRACTITIONERS. DECISIONS REGARDING USER ELIGIBILITY IN
                    PARTICIPATING IN WELLNESS PROGRAM AND USING THE APPLICATION
                    AND THE SERVICES IN THIS REGARD ARE AT THE SOLE DISCRETION
                    OF THE ORGANIZER OF THE WELLNESS PROGRAM. CONSEQUENTLY, USER
                    RELATIONSHIP WITH THIS APPLICATION IS CONTINGENT BY THE
                    TERMS AND CONDITIONS SET BY THE ORGANIZER OF THE WELLNESS
                    PROGRAM, AND USERS ACKNOWLEDGE AND AGREE THAT ANY CHANGES IN
                    THAT RELATIONSHIP MAY DIRECTLY IMPACT USER ACCESS TO THE
                    APPLICATION AND THE SERVICES.
                </Paragraph>

                <Paragraph>
                    THE APPLICATION PROVIDER ASSUMES NO RESPONSIBILITY FOR THE
                    ORGANIZER OF THE WELLNESS PROGRAM'S DECISIONS REGARDING USER
                    ACCESS AND THE TERMS UNDER WHICH THE ACCESS TO THE
                    APPLICATION IS PROVIDED.
                </Paragraph>

                <Paragraph>
                    USERS ACKNOWLEDGE AND AGREE THAT THE ORGANIZER OF THE
                    WELLNESS PROGRAM, AS THE USER'S DATA CONTROLLER, IS SOLELY
                    RESPONSIBLE FOR ALL MATTERS RELATED TO THE CONTENT UPLOADED,
                    TRANSMITTED, OR MADE AVAILABLE THROUGH THE APPLICATION. THIS
                    INCLUDES ALL USER DATA AND ANY INFORMATION ACCESSIBLE VIA
                    THE APPLICATION AND ITS SERVICES. ANY CLAIMS OR ISSUES
                    RELATED TO USER CONTENT OR CONTENT AVAILABLE ON THE
                    APPLICATION SHOULD BE DIRECTED TO THE ORGANIZER OF THE
                    WELLNESS PROGRAM. ONLY THE ORGANIZER OF THE WELLNESS PROGRAM
                    HAS DIRECT AUTHORITY AND CONTROL OVER THE CONTENT AVAILABLE
                    ON THE APPLICATION USER CONTENT. THE PROVIDER OF THE
                    APPLICATION DOES NOT HAVE ACCESS TO USER ACCOUNTS AND/OR
                    USER INDIVIDUAL DATA AND THEREFORE BEARS NO RESPONSIBILITY
                    FOR SUCH MATTERS.
                </Paragraph>

                <Strong>
                    THE ORGANIZER OF THE WELLNESS PROGRAM AND THE AUTHORIZED
                    PERSONNEL AS INDEPENDENT MEDICAL INSTITUTION AND
                    PRACTITIONERS
                </Strong>

                <Paragraph>
                    THE PROVIDER OF THE APPLICATION OPERATES INDEPENDENTLY OF
                    THE ORGANIZER OF THE WELLNESS PROGRAM AND THE AUTHORIZED
                    PERSONNEL AND IS NOT INVOLVED IN ANY WAY IN THEIR
                    PROFESSIONAL ACTIVITY. THE PROVIDER OF THE APPLICATION IS
                    NOT LIABLE FOR THE ACTIONS AND OMISSIONS OF THE ORGANIZER OF
                    THE WELLNESS PROGRAM AND THE AUTHORIZED PERSONNEL, OR THE
                    CONTENT OF THEIR COMMUNICATIONS. THE ORGANIZER OF THE
                    WELLNESS PROGRAM AND THE AUTHORIZED PERSONNEL ACT
                    INDEPENDENTLY AND AT THEIR DISCRETION WHEN PROVIDING
                    SERVICES (INCLUDING MEDICAL/TELEMONITORING OR OTHER RELATED
                    SERVICES) TO THE USERS. ANY SERVICES (INCLUDING
                    MEDICAL/TELEMONITORING OR OTHER RELATED SERVICES) PROVIDED
                    BY THE ORGANIZER OF THE WELLNESS PROGRAM AND THE AUTHORIZED
                    PERSONNEL THROUGH THE APPLICATION AND/OR UTILIZING
                    APPLICATION CONTENT AND DATA, ARE EXCLUSIVELY OFFERED AND
                    PROVIDED BY THEM, ENTIRELY AT THEIR DISCRETION, AND UNDER
                    THEIR SOLE RESPONSIBILITY.
                </Paragraph>

                <Paragraph>
                    THE USERS OF THE APPLICATION ACCEPT AND AGREE THAT ANY
                    SERVICES, MEDICAL MONITORING, MEDICAL ANALYSIS, ADVICE,
                    RECOMMENDATION AND/OR NOTIFICATION IN ANY FORM, PROVIDED
                    THROUGH THE APPLICATION AND/OR ITS FEATURES, OR BY ANY OTHER
                    MEANS OF COMMUNICATION, ARE SOLELY PROVIDED BY THE
                    RESPECTIVE INDEPENDENT ORGANIZER OF THE WELLNESS PROGRAM
                    AND/OR THE AUTHORIZED PERSONNEL. THE APPLICATION AND ITS
                    PROVIDER DO NOT ASSUME ANY RESPONSIBILITY OR LIABILITY FOR
                    THE ACCURACY, COMPLETENESS, RELIABILITY, OR USEFULNESS OF
                    ANY SERVICES, ANALYSIS, ADVICE, RECOMMENDATION AND/OR
                    NOTIFICATION, OR INFORMATION PROVIDED BY THE ORGANIZER OF
                    THE WELLNESS PROGRAM AND/OR THE AUTHORIZED PERSONNEL THROUGH
                    THE APPLICATION AND/OR BASED ON INFORMATION AVAILABLE ON THE
                    APPLICATION. USERS ACKNOWLEDGE THAT ANY RELIANCE ON SUCH
                    INFORMATION IS AT THEIR OWN RISK. USERS ARE SOLELY
                    RESPONSIBLE FOR THEIR OWN ACTIONS AND DECISIONS MADE BASED
                    ON THE SERVICES, ANALYSIS, ADVICE, RECOMMENDATION AND/OR
                    NOTIFICATION PROVIDED THROUGH THE APPLICATION BY THE
                    RESPECTIVE ORGANIZER OF THE WELLNESS PROGRAM AND/OR BY THE
                    AUTHORIZED PERSONNEL. THE APPLICATION AND THE PROVIDER SHALL
                    NOT BE LIABLE FOR ANY DAMAGES, LOSSES, OR LIABILITIES
                    ARISING FROM USER ACTIONS OR DECISIONS BASED ON THE
                    SERVICES, ANALYSIS, ADVICE, RECOMMENDATION, INFORMATION
                    AND/OR NOTIFICATION PROVIDED THROUGH THE APPLICATION.
                </Paragraph>

                <Paragraph>
                    USERS ARE ENCOURAGED TO CONSULT A PHYSICIAN AND MEDICAL
                    PRACTITIONERS BEFORE MAKING ANY CHANGES TO THEIR WELLNESS
                    AND/OR HEALTH HABITS OR ACTIVITY BASED ON INFORMATION
                    PROVIDED THROUGH THE APPLICATION AND THE SERVICES, OR IF
                    THEY HAVE ANY QUESTIONS REGARDING A MEDICAL CONDITION. THE
                    PROVIDER IS NOT RESPONSIBLE FOR ANY WELLNESS AND/OR HEALTH
                    PROBLEMS THAT MAY RESULT FROM INFORMATION USER LEARNS ABOUT
                    THROUGH THE APPLICATION AND THE SERVICES. IF USERS MAKE ANY
                    CHANGE TO THEIR WELLNESS AND/OR HEALTH HABITS AND/OR
                    ACTIVITY, BASED ON THE APPLICATION AND/OR THE SERVICES,
                    USERS AGREE THAT THEY DO SO FULLY AT THEIR OWN RISK.
                </Paragraph>

                <Strong>CONTENT BY THIRD PARTIES</Strong>

                <Paragraph>
                    THE APPLICATION AND THE SERVICES MAY PROVIDE LINKS TO
                    WEBSITES MAINTAINED BY THIRD PARTIES. USERS ACKNOWLEDGE AND
                    AGREE THAT SUCH LINKS ARE PROVIDED FOR THEIR CONVENIENCE
                    ONLY AND DO NOT REFLECT ANY ENDORSEMENT, AFFILIATION,
                    RELATIONSHIP, OR SPONSORSHIP BY THE PROVIDER WITH RESPECT TO
                    SPECIFIC PROVIDER OF SUCH LINKED SITE OR THE QUALITY,
                    RELIABILITY, OR ANY OTHER CHARACTERISTIC OR FEATURE OF SUCH
                    LINKED SITE. USERS FURTHER ACKNOWLEDGE AND AGREE THAT THE
                    PROVIDER IS NOT RESPONSIBLE IN ANY MANNER (INCLUDING WITHOUT
                    LIMITATION WITH RESPECT TO ANY LOSS OR INJURY USER MAY
                    SUFFER) FOR ANY MATTER ASSOCIATED WITH THE LINKED SITE,
                    INCLUDING WITHOUT LIMITATION, THE CONTENT PROVIDED ON OR
                    THROUGH ANY SUCH LINKED SITE OR USER RELIANCE THEREON. IN
                    ADDITION, USERS SHOULD BE AWARE THAT THEIR USE OF ANY
                    THIRD-PARTY SITE IS SUBJECT TO THE TERMS AND CONDITIONS
                    APPLICABLE TO THAT SITE, INCLUDING THE PRIVACY POLICIES (OR
                    LACK THEREOF) OF SUCH SITE. IF A THIRD-PARTY LINKS TO THE
                    APPLICATION AND THE SERVICES, IT IS NOT NECESSARILY AN
                    INDICATION OF ENDORSEMENT, AFFILIATION, RELATIONSHIP, OR
                    SPONSORSHIP BY OR WITH THE PROVIDER. THE PROVIDER MAY NOT
                    EVEN BE AWARE THAT A THIRD PARTY HAS LINKED TO THE
                    APPLICATION AND THE SERVICES.
                </Paragraph>
                <strong></strong>
            </Section>
            <Section title="XIII. LIMITATION OF LIABILITY">
                <Paragraph>
                    IN NO EVENT WILL THE PROVIDER, ITS SUBSIDIARIES, AFFILIATES,
                    OFFICERS, DIRECTORS, EMPLOYEES, REPRESENTATIVES, AGENTS,
                    PARTNERS, AND LICENSORS BE LIABLE FOR DAMAGES OF ANY KIND,
                    UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH
                    USERS USE, OR INABILITY TO USE, THE APPLICATION AND/OR THE
                    SERVICES OR ANY CONTENT ASSOCIATED WITH THE APPLICATION AND
                    THE SERVICES, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
                    APPLICATION AND THE SERVICES, INCLUDING ANY DIRECT,
                    INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE
                    DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN
                    AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF
                    PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF
                    BUSINESS OPPORTUNITY, BUSINESS INTERRUPTION, LOSS OF USE,
                    LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT
                    (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE,
                    EVEN IF FORESEEABLE. THESE EXCLUSIONS OR LIMITATIONS WILL
                    APPLY REGARDLESS OF WHETHER OR NOT THE PROVIDER HAS BEEN
                    WARNED OF THE POSSIBILITY OF SUCH DAMAGES.
                </Paragraph>

                <Paragraph>
                    THE PROVIDER DOES NOT GUARANTEE THAT THE APPLICATION IS
                    CONTINUOUS AND AT ALL TIMES SECURE, SAFE, FUNCTIONS PROPERLY
                    WITHOUT INTERRUPTION AND WILL BE ERROR-FREE OR THAT THE
                    SERVER THROUGH WHICH THE WELLNESS DATA OF THE USER IS
                    PROCESSED IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                </Paragraph>

                <Paragraph>
                    THE PROVIDER IS NOT RESPONSIBLE FOR ANY DAMAGE CAUSED TO THE
                    SOFTWARE OR HARDWARE OF THE ANY DEVICE USED BY THE USER OR
                    FOR THE LOSS OF THE USER'S DATA CAUSED BY THE USE OF THE
                    APPLICATION.
                </Paragraph>

                <Paragraph>
                    THE PROVIDER IS NOT RESPONSIBLE FOR ANY ERRORS OR
                    INACCURACIES IN THE INFORMATION CONTAINED IN THE APPLICATION
                    AND OR THE SERVICES.
                </Paragraph>

                <Paragraph>
                    THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE
                    EXCLUDED OR LIMITED UNDER APPLICABLE LAW. TO THE EXTENT
                    LIABILITY CANNOT BE EXCLUDED OR LIMITED AS SET FORTH ABOVE,
                    IN NO EVENT SHALL THE PROVIDER BE LIABLE FOR ANY CLAIM,
                    WHETHER IN CONTRACT, TORT, OR UNDER ANY OTHER THEORY OF
                    LIABILITY, IN EXCESS OF EUR 200.
                </Paragraph>
            </Section>
            <Section title="XIV. AI TECHNOLOGY">
                <Paragraph>
                    Some of the Services (such as the Notification feature) made
                    available through the Application may include AI and LLM
                    technologies. Some AI Technology, including third party LLM
                    made available through the Services, may allow Users to
                    receive AI Technology generated content, recommendations,
                    data, or other information through the Application and the
                    Services (“Output”).
                </Paragraph>
                <List
                    items={[
                        `Users acknowledge and agree that, in addition to the limitations and restrictions set forth in this Agreement, there are numerous limitations that apply with respect to AI Technology and the Output it generates, including that (i) it may contain errors or misleading information and may not be accurate or reliable; (ii) AI Technology is based on predefined rules and algorithms that lack the ability to think creatively and come up with new ideas and can result in repetitive or formulaic content; (iii) AI Technology can struggle with understanding the nuances of language, including slang, idioms, and cultural references, which can result in Output that is out of context or does not make sense; (iv) AI Technology does not have emotions and cannot understand or convey emotions in the way humans can, which can result in Output that lacks the empathy and emotion that humans are able to convey; (v) AI Technology can perpetuate biases that are present in the data used to train them, which can result in Output that is discriminatory or offensive; (vi) AI Technology can struggle with complex tasks that require reasoning, judgment and decision-making; (vii) AI Technology require large amounts of data to train and generate content, and the data used to train AI Technology may be of poor quality or biased, which will negatively impact the accuracy and quality of the generated Output; and (viii) AI Technology-generated Output can lack the personal touch that comes with content created by humans, which can make it seem cold and impersonal.`,
                        `Users will use independent judgement and discretion before relying on or otherwise using Output. Output is for informational purposes only and is not a substitute for advice from a qualified clinical professional.`,
                        `To the fullest extent permitted by law, the Provider bears no liability to Users or anyone else arising from or relating to Users’ use of AI Technology. `,
                    ]}
                />
            </Section>{' '}
            <Section title="XV. Termination ">
                <Paragraph>
                    This Agreement shall continue in full force until terminated
                    or cancelled pursuant to this Agreement.
                </Paragraph>

                <Paragraph>
                    Unless otherwise prohibited by law, and without prejudice to
                    Provider’s other rights or remedies, the Provider shall have
                    the right to terminate this Agreement: (i) for any reason
                    whatsoever by providing thirty (30) days' notice to the
                    User; (ii) immediately for User’s material breach of this
                    Agreement.
                </Paragraph>

                <Paragraph>
                    Users may terminate this Agreement for any reason whatsoever
                    by providing thirty (30) days' notice to the Organizer of
                    the Wellness Program by visiting the “Cancel My Account”
                    page in their Accounts, which will send a notification to
                    the Organizer of the Wellness Program. After confirmation by
                    the Organizer of the Wellness Program, the User’s Account
                    shall be terminated. With the submission of a request for
                    termination, the User has the option to request from the
                    Organizer of the Wellness Program all User’ Data available
                    on the Application to be deleted.
                </Paragraph>

                <Paragraph>
                    In addition, the User's Account is automatically terminated,
                    without any notices, in the event that the license agreement
                    for the use of the Application between the Provider and the
                    Organizer of the Wellness Program is canceled or terminated;
                    as well as after confirmation from the Organizer of the
                    Wellness Program, when the agreement for participation in
                    the Wellness Program concluded between the User and the
                    Organizer of the Wellness Program is canceled or terminated.
                </Paragraph>

                <Paragraph>
                    Upon cancellation or termination, all licenses granted to
                    Users hereunder shall terminate automatically, Users' right
                    to use the Services shall cease, and Users' content will no
                    longer be available to the Users through the Application and
                    the Services.
                </Paragraph>

                <Paragraph>
                    Sections in this Agreement titled Intellectual Property,
                    Data protection, Indemnification, Warranty Disclaimer,
                    Limitation of Liability, and Governing Law shall survive
                    termination and/or cancellation of this Agreement for any
                    reason whatsoever.
                </Paragraph>
            </Section>
            <Section title="XV. Indemnification ">
                User agree to indemnify, hold harmless, and defend the Provider,
                its subsidiaries, affiliates, officers, directors, employees,
                representatives, agents, partners, licensors, successors, and
                assigns, from and against any action, cause, claim, damage,
                debt, demand, or liability, including reasonable costs and
                attorneys' fees, asserted by any person, arising out of or
                relating to (i) use of the Application and/or the Services,
                including but not limited to anyone using User’s account or
                Credentials; (ii) breach of this Agreement by the Users or
                anyone using their Account or Credentials; (iii) any information
                used, stored, or transmitted in connection with User’s account
                or Credentials; (iv) breach of the rights of any third party,
                including but not limited to privacy, publicity, intellectual
                property, or other proprietary rights by the Users or anyone
                using their Account or Credentials; or (v) violation of any law,
                regulation, or other legal requirement.
            </Section>
            <Section title="XVI. Governing Law and Jurisdiction ">
                <Paragraph>
                    For all matters not settled in these Agreement and
                    attachments to it, the relevant provisions of the English
                    law will apply. Applicable to any disputes between the
                    Provider and the Users of the Application will be the
                    English law, and if no agreement is reached between the
                    parties, the dispute should be referred to the competent
                    English court. If a User lives outside of England, both the
                    User and the Provider can bring legal proceedings in respect
                    of the Application and the Services or this Agreement in
                    either local courts or the English courts.{' '}
                </Paragraph>
            </Section>
            <Section title="XVIII. No Technical Support and Complains">
                <Paragraph>
                    Users agree that the Provider has no obligation to provide
                    technical, maintenance or other support relating to the
                    Application and the Services (including the Smart
                    wearables).
                </Paragraph>

                <Paragraph>
                    For any technical issues, concerns, or complaints related to
                    the use of this Application and the Services (including for
                    the Smart wearables), Users shall contact the Organizer of
                    the Wellness Program through whom they are provided with
                    access to the Application. The Provider does not assume any
                    responsibility or liability for technical problems,
                    malfunctions, or User dissatisfaction and/or complaints.
                </Paragraph>

                <Paragraph>
                    All support, troubleshooting, and resolution of issues are
                    managed solely by the Organizer of the Wellness Program.
                    Users acknowledge and agree that the Application Provider
                    does not handle User complaints or technical inquiries and
                    is not responsible for any outcomes related to such matters.
                </Paragraph>
            </Section>
            <Section title="XIX. Severability">
                <Paragraph>
                    If any of the terms or conditions of this Agreement is
                    deemed invalid, void or for any reason unenforceable, that
                    provision shall be deemed severable and shall not affect the
                    validity and enforceability of any remaining part of this
                    Agreement.
                </Paragraph>
            </Section>
            <Section title="XX. Changes to this Agreement ">
                <Paragraph>
                    The Provider reserves the right at any time and without
                    prior notice (for non-material changes) to make changes to
                    this Agreement and attachments to it. Such changes will be
                    effective upon posting such amendments to the Application
                    website. User’s continued use of the Application and
                    Services offered after the date the amended Agreement and
                    attachments to it are uploaded, shall constitute User’s
                    acceptance of such amendments.
                </Paragraph>
            </Section>
            <Section title="XXI. Third Party Distribution Channels  ">
                <Paragraph>
                    The Application offers software applications that may be
                    made available through the Apple App Store, the Google Play
                    Store or other distribution channels (“Distribution
                    Channels”).
                </Paragraph>

                <Paragraph>
                    Users that obtain such software through a Distribution
                    Channel shall be subject to additional terms of the
                    Distribution Channel. This Agreement is between Users and
                    the Provider only, and not with the Distribution Channel. To
                    the extent that Users utilize any other third-party products
                    and services in connection with their use of the Application
                    and the Services, Users agree to comply with all applicable
                    terms of any agreement for such third-party products and
                    services.
                </Paragraph>

                <Paragraph>
                    With respect to Software that is made available for Users in
                    connection with an Apple-branded product (such Software,
                    “Apple-Enabled Software”), in addition to the other terms
                    and conditions set forth in this Agreement, the terms and
                    conditions applicable to those Apple-branded product shall
                    apply. Such terms and conditions are available in the
                    respective official Apple website and as they may be subject
                    to amendment which is out of Provider’s control, it is Users
                    responsibility for regularly reviewing for any updates of
                    the applicable terms of any agreement for such third-party
                    products and services.
                </Paragraph>

                <Paragraph>
                    With respect to Software that is made available for use in
                    connection with a Samsung-branded product (such Software,
                    “Samsung-Enabled Software”), in addition to the other terms
                    and conditions set forth in this Agreement, the terms and
                    conditions applicable to those Samsung-branded product shall
                    apply. Such terms and conditions are available in the
                    respective official Samsung website and as they may be
                    subject to amendment which is out of Provider’s control, it
                    is Users responsibility for regularly reviewing for any
                    updates of the applicable terms of any agreement for such
                    third-party products and services.
                </Paragraph>

                <Paragraph>
                    By engaging with these Distribution Channel, Users agree
                    that such access, use, or purchase will be governed by the
                    terms and conditions of the respective third-party
                    providers. The Provider is not responsible for any issues,
                    claims, or disputes arising from Users interactions with
                    such third-party providers. Any transactions, usage, or
                    interactions that Users engage in with these third-party
                    services are governed by the terms and conditions of the
                    respective third parties. By accessing such services through
                    the Application, Users acknowledge and agree to be bound by
                    those terms. The Provider disclaim all liability for any
                    claims, damages, or issues arising from or related to these
                    third-party offerings. Any questions, complaints, or claims
                    regarding any third-party products or services, Users should
                    address directly to the relevant third party.
                </Paragraph>
            </Section>
            <Section title="XX. Changes to this Agreement ">
                <h5 className="font-bold">
                    For Users of I am OK Application:{' '}
                </h5>
                <Paragraph>
                    Mailing address: {` `}
                    <Strong>
                        13 Tsvetarska Str., Dragalevtsi district, Vitosha
                        region, Sofia 1415, Bulgaria
                    </Strong>
                </Paragraph>

                <Paragraph>
                    {' '}
                    Email address: <Strong> support@430pm.bg</Strong>
                </Paragraph>

                <Paragraph>
                    {' '}
                    Tel.: <Strong> +359 87 7884332</Strong>
                </Paragraph>
                <br />

                <Paragraph>
                    <strong>For Users of TaVie Application:</strong>
                </Paragraph>

                <Strong>ThinkShield Ltd.</Strong>

                <Paragraph>
                    Mailing address:{' '}
                    <Strong>
                        4 The Arches, Furmston Court, Icknield Way, Letworth
                        Garden City SG6 1UJ
                    </Strong>
                </Paragraph>

                <Paragraph>
                    Email address:
                    <Strong>support@taviewear.com</Strong>
                </Paragraph>

                <Paragraph>
                    Tel.: <Strong>+447889 128923</Strong>{' '}
                </Paragraph>
            </Section>
        </React.Fragment>
    )
}
const Section = ({title, children}) => (
    <div className="terms-section mb-3">
        <h2 className="terms-title">{title}</h2>
        <h5 className="terms-content">{children}</h5>
    </div>
)

const Paragraph = ({children}) => (
    <h5 className="terms-paragraph text-2xl">{children}</h5>
)
const Strong = ({children}) => (
    <strong className="text-darkcyan">{children}</strong>
)
const List = ({items, type}) => (
    <ul className={`terms-list ${type}`}>
        {items.map((item, index) => (
            <li key={index} className="terms-list-item mb-1">
                {item}
            </li>
        ))}
    </ul>
)
export default TermsDoc
